export const LogoutEvent = 'logout'
export const DismissModalEvent = 'dismissModal'
export const PlayerActionTimerExpired = 'PlayerActionTimerExpired'
